import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import useGoogleClientIdGet from 'Hooks/Common/useGoogleClientIdGet';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();
  const clientId = useGoogleClientIdGet();

  return useAsyncAction(
    () => clientId && $actions.user.updateGoolgeClientId(dispatch, { clientId }),
  );
};
